<template>
    <div>
        <van-nav-bar
                title="我的电子票"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="onNavClickLeft"
        />

        <van-tabs v-model="activeIndex">
            <van-tab title="待使用">
                <ticket-list :p_action="1" />
            </van-tab>
            <van-tab title="已核销">
                <ticket-list :p_action="2" />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import TicketList from "../../components/Order/TicketList";

    export default {
        name: "MyTicket",
        components: {TicketList},
        data(){
            return{
                activeIndex:this.$route.params.active?this.$route.params.active:0,
            }
        },
        methods:{
            onNavClickLeft(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>